import vendor from "fragments/vendors/vendor"
import { gql } from "graphql-tag"

const GET_VENDORS = gql`
  ${vendor}

  query getVendors($query: GetQueryVendors) {
    getVendors(query: $query) {
      ...Vendor
    }
  }
`

export default GET_VENDORS
